import { hexToCSSFilter } from 'hex-to-css-filter';
import React, { FC } from 'react';
import { GlobalStylesHTML } from 'src/components/GlobalStyles';
import { useSelector, RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { MultipleChoiceSurveyStyles } from './initStyles';

const MultipleChoiceSurveyHTML: FC = () => {
  const templateId = useSelector(
    (state: RootState) => state.template.templateId
  );

  const templateTitle = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  const hash = useSelector((state: RootState) => state.template.hash);

  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  const logCustom = useSelector(
    (state: RootState) => state.trackings.logCustom
  );

  const CLOSE_FILTER = bgColor?.close
    ?.map(
      (_, idx) =>
        `"${hexToCSSFilter(bgColor?.close?.[idx]).filter.replaceAll(';', '')}"`
    )
    .join(',');

  const BACK_FILTER = bgColor?.back
    ?.map(
      (_, idx) =>
        `"${hexToCSSFilter(bgColor?.back?.[idx]).filter.replaceAll(';', '')}"`
    )
    .join(',');

  const style = `
    .root_view {
      ${
        bg?.background === 'image'
          ? `background-image: url(${bgImage?.background?.[0]})`
          : `background: ${bgColor?.background?.[0]}`
      };
      .close_btn {
        filter: ${CLOSE_FILTER?.replaceAll('"', '')?.split(',')[0].filter};
      }
      .back_btn {
        opacity: 0;
        filter: ${BACK_FILTER?.replaceAll('"', '')?.split(',')[0].filter};
      }
    }
  `;

  const html = `
    <div class="root_view">
      <div class="liquid">
        <p class="user_id">{{\${user_id}}}</p>
        <p class="email_address">{{\${email_address}}}</p>
        <p class="first_name">{{\${first_name}}}</p>
        <p class="last_name">{{\${last_name}}}</p>
      </div>
      <div class="template">
        <div class="center_horizon top_wrapper">
          <button class="back_btn"></button>
          <button class="close_btn"></button>
        </div>
        <div class="center_wrapper">
          <div>
            <div class="title">
              <div class="title_inner">
                ${changeEnterHTML(text?.title?.[0])}
              </div>
            </div>
            <div class="sub_title">
              <div class="sub_title_inner">
                ${changeEnterHTML(text?.sub_title?.[0])}
              </div>
            </div>
          </div>
          <div class="survey_wrapper"></div>
        </div>
        <div class="center_horizon btn_wrapper">
          <button class="btn_inner">
            ${changeEnterHTML(btnText?.button?.[0])}
          </button>
        </div>
      </div>
    </div>
  `;

  const option_list = `<div class="survey_line">
      <div class="survey_action_line"></div>
    </div>${btnText?.option_button
      ?.map((multi_survey: any, idx: number) =>
        multi_survey
          ?.map(
            (survey: any, idx2: number) => `
            <div id="${idx2}" class="survey survey_${idx}">
              <button id="${idx2}" class="survey_button_${idx} survey_button_${idx}_${idx2}">${changeEnterHTML(
              survey
            )}</button>
            </div>`
          )
          .join('')
      )
      .join('')}`;

  const TEMPLATES_LEN =
    bgImage?.background?.length || bgImage?.image?.length || text?.text?.length;
  const js = `
    document.addEventListener("DOMContentLoaded", function() {
      let currentIndex = 0;
      let bg = ${JSON.stringify(bg)};
      let bgImage = ${JSON.stringify(bgImage)};
      let bgColor = ${JSON.stringify(bgColor)};
      let text = ${JSON.stringify(text)};
      let btnText = ${JSON.stringify(btnText)};
      let option = \`${option_list}\`;
      const CLOSE_FILTER = [${CLOSE_FILTER}];
      const BACK_FILTER = [${BACK_FILTER}];

      $('.survey_wrapper').html(option);
      $('.survey').css("display", "none");
      $('.survey_0').css("display", "block");

      let pre_answer = [${Array.from({ length: TEMPLATES_LEN }, () => '[]')}];
      const changePage = () => {
        $('.back_btn').css("opacity", 1);
        if (currentIndex === 0) $('.back_btn').css("opacity", 0);

        $('.survey').css("display", "none");
        $('.survey_'+currentIndex).css("display", "block");

        $('.survey_action_line').css('width', (currentIndex / (bgImage?.background?.length - 1)) * 100 + '%');
        if (bg?.background === 'image') $('.root_view').css("background-image", "url("+bgImage.background[currentIndex]+")");
        else $('.root_view').css("background", bgColor.background[currentIndex]);
        $('.close_btn').css("filter", CLOSE_FILTER[currentIndex]);
        $('.back_btn').css("filter", BACK_FILTER[currentIndex]);
        $('.title_inner').text(text.title[currentIndex]);
        $('.sub_title_inner').text(text.sub_title[currentIndex]);
        $('.btn_inner').text(btnText.button[currentIndex]);
        if (pre_answer[currentIndex].length === 0) $('.btn_inner').removeClass('action');
        else $('.btn_inner').addClass('action');
      }

      let idx = -1;
      <!-- 옵션선택 -->
      $('.survey').click(function() {
        idx = $(this).attr('id');
        let action = $('.survey_button_' + currentIndex + '_' + idx).hasClass('action');
        if (action) {
          pre_answer[currentIndex] = pre_answer[currentIndex].filter((data) => data !== idx);
          $('.survey_button_' + currentIndex + "_" + idx).removeClass('action');
          if (pre_answer[currentIndex].length === 0) $('.btn_inner').removeClass('action');
        } else {
          pre_answer[currentIndex].push(idx);
          $('.survey_button_' + currentIndex + '_' + idx).addClass('action');
          $('.btn_inner').addClass('action');
        }
      });

      let tracking = ${JSON.stringify(tracking)};
      let button1 = ${JSON.stringify(button1)};
      let button2 = ${JSON.stringify(button2)};
      let logCustom = ${JSON.stringify(logCustom)};

      <!-- 닫기 -->
      $('.close_btn').click(function() {
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.close[currentIndex]);

        <!-- button 트래킹 -->
        try {
          if (button1.close.indexOf(currentIndex) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.close.indexOf(currentIndex) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        brazeBridge.closeMessage();
      });

      <!-- 뒤로가기 -->
      $('.back_btn').click(function() {
        let newCurrentIndex = currentIndex - 1;

        if (newCurrentIndex > -1) {
          currentIndex = newCurrentIndex;
          changePage();
        }
      })

      <!-- 앞으로가기 -->
      $('.btn_inner').click(function() {
        if (pre_answer[currentIndex].length === 0) return;
  
        let newCurrentIndex = currentIndex + 1;
        <!-- custom 트래킹 -->
        brazeBridge.logClick(tracking.button[currentIndex]);

        <!-- button 트래킹 -->
        try {
          if (button1.button.indexOf(currentIndex) !== -1) {
            brazeBridge.logClick('0');
          }
        } catch (err) {}
        try {
          if (button2.button.indexOf(currentIndex) !== -1) {
            brazeBridge.logClick('1');
          }
        } catch (err) {}

        if (newCurrentIndex < bgImage.background.length) {
          currentIndex = newCurrentIndex;
          changePage();
        } else {
          <!-- liquid 값 -->
          let user = {};
          user.user_id = $('.user_id').text();
          user.email = $('.email_address').text();
          user.first_name = $('.first_name').text();
          user.last_name = $('.last_name').text();

          let answer = [];
          for (let i = 0; i < pre_answer.length; i++) {
            answer.push({
              user_id: user.user_id,
              question: text.title[i],
              selected: [],
            });
  
            for (let j = 0; j < pre_answer[i].length; j++) {
              <!-- 설문조사 최종 값 -->
              let jj = pre_answer[i][j];
              let selected_text = $('.survey_button_' + i + '_' + jj).text();
              answer[answer.length - 1].selected.push(selected_text);
  
              <!-- custom 로그 -->
              if (logCustom.type[i][jj] === "attribute") {
                brazeBridge.getUser().setCustomUserAttribute(log_custom.multi_action_survey[i][jj], selected_text);
              }
              if (logCustom.type[i][jj] === "event") {
                brazeBridge.logCustomEvent(log_custom.multi_action_survey[i][jj]);
              }

              <!-- custom 트래킹 -->
              brazeBridge.logClick(tracking.option_button[i][jj]);

              <!-- button 트래킹 -->
              try {
                if (button1.option_button.indexOf(i+":"+j) !== -1) {
                  brazeBridge.logClick('0');
                }
              } catch (err) {}
              try {
                if (button2.option_button.indexOf(i+":"+j) !== -1) {
                  brazeBridge.logClick('1');
                }
              } catch (err) {}
            }
          }

          <!-- 설문조사 최종 값 보내기 -->
          try {
            $.ajax({
              type : 'post',
              url : '${process.env.REACT_APP_API_URL}/events',
              async : true,
              headers : {
                "Content-Type" : "application/json"
              },
              data : JSON.stringify({
                "template_id": "${templateId}" !== "undefined" ? "${templateId}" : templateId,
                "hash": "${hash}" !== "null" ? "${hash}" : hash,
                "template_name": "${templateTitle}",
                "user": user,
                "client_submit_timestamp": new Date().getTime(),
                "attributes": answer
              }),
              success : function(result) {
              },    
              error : function(request, status, error) {
              }
            })
          } catch (err) {}

          brazeBridge.closeMessage();
        }
      });
    });
  `;

  return (
    <>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <style
        dangerouslySetInnerHTML={{
          __html: GlobalStylesHTML() + MultipleChoiceSurveyStyles() + style
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default MultipleChoiceSurveyHTML;
